/**
 * Décode les entités HTML courantes dans un nom / prénom
 * (`N&apos;faly` → `N'faly`, y compris le double encodage `&amp;apos;`).
 */
export function decodeHtmlEntities(raw: string | null | undefined): string {
	if (raw == null) return ''
	let value = String(raw)
	if (!value.includes('&')) return value

	const decodeOnce = (s: string) =>
		s
			.replace(/&nbsp;/gi, ' ')
			.replace(/&apos;/gi, "'")
			.replace(/&quot;/gi, '"')
			.replace(/&lt;/gi, '<')
			.replace(/&gt;/gi, '>')
			.replace(/&#x([0-9a-f]+);/gi, (match, hex: string) => {
				const code = parseInt(hex, 16)
				if (!Number.isFinite(code) || code < 0 || code > 0x10ffff) return match
				return String.fromCodePoint(code)
			})
			.replace(/&#(\d+);/g, (match, dec: string) => {
				const code = Number(dec)
				if (!Number.isFinite(code) || code < 0 || code > 0x10ffff) return match
				return String.fromCodePoint(code)
			})
			.replace(/&amp;/gi, '&')

	let previous = value
	for (let i = 0; i < 3; i++) {
		const next = decodeOnce(previous)
		if (next === previous) break
		previous = next
	}
	return previous
}

/** Première valeur non vide, après trim + décodage HTML. */
export function firstDecodedNamePart(
	...values: Array<string | null | undefined>
): string {
	for (const value of values) {
		const cleaned = decodeHtmlEntities(value).trim()
		if (cleaned) return cleaned
	}
	return ''
}
